var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_160748",
    "data-name": "Group 160748",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1422",
    "data-name": "Group 1422",
    transform: "translate(5.703 5.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1421",
    "data-name": "Group 1421"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    x1: 6,
    y2: 6,
    transform: "translate(0.297 0.297)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    x2: 6,
    y2: 6,
    transform: "translate(0.297 0.297)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_559",
    "data-name": "Rectangle 559",
    width: 18,
    height: 18,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/Cross-icon.a4afc0fd2cd6c5ad745a0b0d1a77e887.svg";
export { ForwardRef as ReactComponent };